module.exports = __webpack_public_path__ + "static/media/PMInactivo.c8379af1.svg";